// @flow
import React, { Component } from 'react';
import {
  TextArea, Checkbox, Radio, RadioGroup,
} from 'informed';

import { PrimaryText, SecondaryText } from '../../../Typography.jsx';
import ContentBox from '../../../ContentBox.jsx';
import DateText from '../../../DateText.jsx';
import { Button } from '../../../Buttons.jsx';

import styles from '../../../../styles/patientPages/progressNote/progressNote.scss';

type Props = {
  initGastrointestinal: Object,
  resetMouthGumsTeethRadios: Function,
  resetIntestinalRadios: Function,
}

class EditGastrointestinal extends Component<Props> {
  render() {
    const gastrointestinal = this.props.initGastrointestinal || {};
    return (
      <ContentBox title='Gastrointestinal'>
        <div className={styles.col}>
          <PrimaryText>Mouth/Gums/Teeth</PrimaryText><br />
          <Button onClick={this.props.resetMouthGumsTeethRadios}>Clear Radios</Button>
          <div className={styles.section}>
            <SecondaryText>Gums and mouth:</SecondaryText><br />
            <RadioGroup field='gastrointestinal.gumsMouth' initialValue={gastrointestinal.gumsMouth}>
              <Radio value='good' />Good condition, no lesions or sores<br />
              <Radio value='good now' />History of lesions or sores, none now<br />
              <Radio value='lesion' />Current oral mucosa/gum lesion or sore<br />
              <Radio value='erythema' />Erythema of oral mucosa<br />
              <Radio value='white patches' />White patches on oral mucosa<br />
              <Radio value='mucositis' />Mucositis (stomatitis)<br />
              <Radio value='gingivitis' />Gingivitis/reddened gums
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Teeth/bridges/dentures:</SecondaryText><br />
            <RadioGroup field='gastrointestinal.teethDentures' initialValue={gastrointestinal.teethDentures}>
              <Radio value='good' />Teeth in good condition<br />
              <Radio value='fair' />Teeth in fair condition<br />
              <Radio value='poor' />Teeth in poor condition<br />
              <Radio value='no teeth' />No natural teeth<br />
              <Radio value='bridges' />Bridges (describe)<br />
              <Radio value='upper dentures' />Upper dentures only<br />
              <Radio value='lower dentures' />Lower dentures only<br />
              <Radio value='upper lower' />Upper and lower dentures<br />
              <Radio value='edentulous' />None, edentulous
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Mouth/gums/teeth Notes:</SecondaryText><br />
            <TextArea field='gastrointestinal.mouthNotes' initialValue={gastrointestinal.mouthNotes} />
          </div>
          <PrimaryText>Esophageal</PrimaryText><br />
          <div className={styles.section}>
            <SecondaryText>Esophageal assessment (mark all that apply):</SecondaryText><br />
            <Checkbox field='gastrointestinal.swallowProblems' initialValue={gastrointestinal.swallowProblems} />Swallowing problems<br />
            <Checkbox field='gastrointestinal.refluxEating' initialValue={gastrointestinal.refluxEating} />Reflux after eating<br />
            <Checkbox field='gastrointestinal.refluxBending' initialValue={gastrointestinal.refluxBending} />Reflux when bending over<br />
            <Checkbox field='gastrointestinal.refluxLying' initialValue={gastrointestinal.refluxLying} />Reflux when lying down<br />
            <Checkbox field='gastrointestinal.heartburn' initialValue={gastrointestinal.heartburn} />Frequent heartburn
          </div>
          <div className={styles.section}>
            <SecondaryText>Esophageal notes:</SecondaryText><br />
            <TextArea field='gastrointestinal.esophagealNotes' initialValue={gastrointestinal.esophagealNotes} />
          </div>
          <PrimaryText>Abdomen</PrimaryText><br />
          <div className={styles.section}>
            <SecondaryText>Abdominal assessment (mark all that apply):</SecondaryText><br />
            <Checkbox field='gastrointestinal.softAb' initialValue={gastrointestinal.softAb} />Soft<br />
            <Checkbox field='gastrointestinal.firmAb' initialValue={gastrointestinal.firmAb} />Firm<br />
            <Checkbox field='gastrointestinal.flatAb' initialValue={gastrointestinal.flatAb} />Flat<br />
            <Checkbox field='gastrointestinal.roundedAb' initialValue={gastrointestinal.roundedAb} />Rounded<br />
            <Checkbox field='gastrointestinal.ascites' initialValue={gastrointestinal.ascites} />Ascites<br />
            <Checkbox field='gastrointestinal.nontenderToPalp' initialValue={gastrointestinal.nontenderToPalp} />Nontender to palpation<br />
            <Checkbox field='gastrointestinal.tenderToLightPalp' initialValue={gastrointestinal.tenderToLightPalp} />Tender to light palpation<br />
            <Checkbox field='gastrointestinal.tenderToDeepPalp' initialValue={gastrointestinal.tenderToDeepPalp} />Tender to deep palpation<br />
            <Checkbox field='gastrointestinal.guardingToPalp' initialValue={gastrointestinal.guardingToPalp} />Guarding to palpation<br />
            <Checkbox field='gastrointestinal.rigidToPalp' initialValue={gastrointestinal.rigidToPalp} />Rigid to palpation<br />
            <br />
            <SecondaryText>If tender on palpation, indicate region:</SecondaryText><br />
            <Checkbox field='gastrointestinal.rightUpperPalp' initialValue={gastrointestinal.rightUpperPalp} />Right upper quadrant<br />
            <Checkbox field='gastrointestinal.leftUpperPalp' initialValue={gastrointestinal.leftUpperPalp} />Left upper quadrant<br />
            <Checkbox field='gastrointestinal.rightLowerPalp' initialValue={gastrointestinal.rightLowerPalp} />Right lower quadrant<br />
            <Checkbox field='gastrointestinal.leftLowerPalp' initialValue={gastrointestinal.leftLowerPalp} />Left lower quadrant<br />
            <Checkbox field='gastrointestinal.epigastric' initialValue={gastrointestinal.epigastric} />Epigastric<br />
            <Checkbox field='gastrointestinal.periumbilical' initialValue={gastrointestinal.periumbilical} />Periumbilical<br />
            <Checkbox field='gastrointestinal.generalized' initialValue={gastrointestinal.generalized} />Generalized
          </div>
          <PrimaryText>Gastrointestinal</PrimaryText><br />
          <div className={styles.section}>
            <Checkbox field='gastrointestinal.noGastricProblems' initialValue={gastrointestinal.noGastricProblems} />No gastric problems noted<br />
          </div>
          <div className={styles.section}>
            <SecondaryText>Mark all that apply:</SecondaryText><br />
            <Checkbox field='gastrointestinal.nausea' initialValue={gastrointestinal.nausea} />Nausea<br />
            <Checkbox field='gastrointestinal.vomiting' initialValue={gastrointestinal.vomiting} />Vomiting<br />
            <Checkbox field='gastrointestinal.epigastricPain' initialValue={gastrointestinal.epigastricPain} />Epigastric pain/distress<br />
            <Checkbox field='gastrointestinal.hemoptysis' initialValue={gastrointestinal.hemoptysis} />Hemoptysis<br />
            <Checkbox field='gastrointestinal.hematemesis' initialValue={gastrointestinal.hematemesis} />Hematemesis<br />
            <Checkbox field='gastrointestinal.abPainCramp' initialValue={gastrointestinal.abPainCramp} />Abdominal pain, cramping<br />
            <Checkbox field='gastrointestinal.abPainSharp' initialValue={gastrointestinal.abPainSharp} />Abdominal pain, sharp
          </div>
          <div className={styles.section}>
            <SecondaryText>Gastrointestinal notes:</SecondaryText><br />
            <TextArea field='gastrointestinal.gastroNotes' initialValue={gastrointestinal.gastroNotes} />
          </div>
          <PrimaryText>Intestinal</PrimaryText><br />
          <Button onClick={this.props.resetIntestinalRadios}>Clear Radios</Button>
          <div className={styles.section}>
            <SecondaryText>Date of last bowel movement: </SecondaryText>
            <DateText field='gastrointestinal.lastBowel' item={{ 'gastrointestinal.lastBowel': gastrointestinal.lastBowel }} initEmpty />
          </div>
          <div className={styles.section}>
            <SecondaryText>Continence of bowel:</SecondaryText><br />
            <RadioGroup field='gastrointestinal.continenceBowel' initialValue={gastrointestinal.continenceBowel}>
              <Radio value='continent' />Continent<br />
              <Radio value='incontinent' />Incontinent<br />
              <Radio value='occasional incontinent' />Occasionally incontinent
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Bowel sounds (mark all that apply):</SecondaryText><br />
            <Checkbox field='gastrointestinal.activeSound' initialValue={gastrointestinal.activeSound} />Active x 4 quadrants<br />
            <Checkbox field='gastrointestinal.hyperactiveSound' initialValue={gastrointestinal.hyperactiveSound} />Hyperactive<br />
            <Checkbox field='gastrointestinal.hypoactiveSound' initialValue={gastrointestinal.hypoactiveSound} />Hypoactive/sluggish<br />
            <Checkbox field='gastrointestinal.notHeard' initialValue={gastrointestinal.notHeard} />Not heard<br />
            <Checkbox field='gastrointestinal.otherSound' initialValue={gastrointestinal.otherSound} />Other (describe in Notes)
          </div>
          <div className={styles.section}>
            <SecondaryText>Intestinal assessment:</SecondaryText><br />
            <Checkbox field='gastrointestinal.noBowelProbs' initialValue={gastrointestinal.noBowelProbs} />No bowel problems noted
          </div>
          <div className={styles.section}>
            <SecondaryText>Mark all that apply:</SecondaryText><br />
            <Checkbox field='gastrointestinal.occasionalDiar' initialValue={gastrointestinal.occasionalDiar} />Occasional diarrhea<br />
            <Checkbox field='gastrointestinal.frequentDiar' initialValue={gastrointestinal.frequentDiar} />Frequent diarrhea<br />
            <Checkbox field='gastrointestinal.explosiveDiar' initialValue={gastrointestinal.explosiveDiar} />Explosive diarrhea<br />
            <Checkbox field='gastrointestinal.occasionalConst' initialValue={gastrointestinal.occasionalConst} />Occasional constipation<br />
            <Checkbox field='gastrointestinal.frequentConst' initialValue={gastrointestinal.frequentConst} />Frequent constipation<br />
            <Checkbox field='gastrointestinal.bloating' initialValue={gastrointestinal.bloating} />Bloating<br />
            <Checkbox field='gastrointestinal.frequentBelch' initialValue={gastrointestinal.frequentBelch} />Frequent belching<br />
            <Checkbox field='gastrointestinal.frequentFlat' initialValue={gastrointestinal.frequentFlat} />Frequent flatulence
          </div>
          <div className={styles.section}>
            <SecondaryText>Stool characteristics (mark all that apply):</SecondaryText><br />
            <Checkbox field='gastrointestinal.firm' initialValue={gastrointestinal.firm} />Firm<br />
            <Checkbox field='gastrointestinal.loose' initialValue={gastrointestinal.loose} />Loose<br />
            <Checkbox field='gastrointestinal.watery' initialValue={gastrointestinal.watery} />Watery<br />
            <Checkbox field='gastrointestinal.hard' initialValue={gastrointestinal.hard} />Hard<br />
            <Checkbox field='gastrointestinal.brown' initialValue={gastrointestinal.brown} />Brown<br />
            <Checkbox field='gastrointestinal.black' initialValue={gastrointestinal.black} />Black<br />
            <Checkbox field='gastrointestinal.green' initialValue={gastrointestinal.green} />Green<br />
            <Checkbox field='gastrointestinal.gray' initialValue={gastrointestinal.gray} />Gray<br />
            <Checkbox field='gastrointestinal.yellow' initialValue={gastrointestinal.yellow} />Yellow<br />
            <Checkbox field='gastrointestinal.tarry' initialValue={gastrointestinal.tarry} />Tarry<br />
            <Checkbox field='gastrointestinal.tan' initialValue={gastrointestinal.tan} />Tan<br />
            <Checkbox field='gastrointestinal.rusty' initialValue={gastrointestinal.rusty} />Rusty<br />
            <Checkbox field='gastrointestinal.bloodStreaked' initialValue={gastrointestinal.bloodStreaked} />Blood-streaked<br />
            <Checkbox field='gastrointestinal.frankBlood' initialValue={gastrointestinal.frankBlood} />Frank blood<br />
            <Checkbox field='gastrointestinal.foulOdor' initialValue={gastrointestinal.foulOdor} />Foul odor
          </div>
          <div className={styles.section}>
            <SecondaryText>Rectum:</SecondaryText><br />
            <Checkbox field='gastrointestinal.noRectalProbs' initialValue={gastrointestinal.noRectalProbs} />No reported rectal problems
          </div>
          <div className={styles.section}>
            <SecondaryText>Rectum characteristics (mark all that apply):</SecondaryText><br />
            <Checkbox field='gastrointestinal.redness' initialValue={gastrointestinal.redness} />Redness<br />
            <Checkbox field='gastrointestinal.irritation' initialValue={gastrointestinal.irritation} />Irritation<br />
            <Checkbox field='gastrointestinal.hemorrhoids' initialValue={gastrointestinal.hemorrhoids} />Hemorrhoids<br />
            <Checkbox field='gastrointestinal.analFistula' initialValue={gastrointestinal.analFistula} />Anal fistula<br />
            <Checkbox field='gastrointestinal.analAbscess' initialValue={gastrointestinal.analAbscess} />Anal abscess<br />
            <Checkbox field='gastrointestinal.analFissure' initialValue={gastrointestinal.analFissure} />Anal fissure<br />
            <Checkbox field='gastrointestinal.rectalProlapse' initialValue={gastrointestinal.rectalProlapse} />Rectal prolapse<br />
            <Checkbox field='gastrointestinal.rectalItching' initialValue={gastrointestinal.rectalItching} />Rectal itching<br />
            <Checkbox field='gastrointestinal.rectalTrauma' initialValue={gastrointestinal.rectalTrauma} />Rectal trauma
          </div>
          <div className={styles.section}>
            <SecondaryText>Intestinal diversion:</SecondaryText><br />
            <Checkbox field='gastrointestinal.ostomy' initialValue={gastrointestinal.ostomy} />Patient has ostomy
          </div>
          <div className={styles.section}>
            <SecondaryText>Intestinal notes:</SecondaryText><br />
            <TextArea field='gastrointestinal.intestinalNotes' initialValue={gastrointestinal.intestinalNotes} />
          </div>
        </div>
      </ContentBox>
    );
  }
}

export default EditGastrointestinal;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/progressNote/edit/EditGastrointestinal.jsx